var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJourney2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aj2{fill:none;}.bj2{fill:#707070;}.cj2{fill:#fff;}.dj2{fill:#b30200;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "aj2",
    width: 96,
    height: 96
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.058 -15.875)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bj2",
    d: "M76.823,95.883v-23.7H89.085L53.621,39.638l-.046-.05,0,0,0,0-.046.05L18.058,72.183H30.32v23.7H22v3.992h85.055V95.883Zm-48.5-27.692L53.571,45.017,78.825,68.192h-6V95.747H61.413V78.2H45.729V95.747H34.323V68.192Zm21.413,14h7.679V95.883H49.732Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.639 30.875)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cj2",
    width: 37,
    height: 39
  })), /*#__PURE__*/React.createElement("path", {
    className: "dj2",
    d: "M106.581,77.875h-45v-47h45Zm-41-4h37v-39h-37Z",
    transform: "translate(-61.581 -30.875)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.139 38.566)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dj2",
    d: "M99.081,50.566h-4v-8h-22v8h-4v-12h30Z",
    transform: "translate(-69.081 -38.566)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.139 58.506)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dj2",
    d: "M99.081,70.566h-30v-12h4v8h22v-8h4Z",
    transform: "translate(-69.081 -58.566)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.116 52.084)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dj2",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.139 52.084)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dj2",
    width: 4,
    height: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourney2);
export default __webpack_public_path__ + "static/media/journey2.d934e4e5e7883aa42a35b3f93a83c5fd.svg";
export { ForwardRef as ReactComponent };